Shopware.Component.override('sw-first-run-wizard-paypal-credentials', () => import('./sw-first-run-wizard/sw-first-run-wizard-paypal-credentials'));

Shopware.Component.override('sw-sales-channel-modal-detail', () => import('./sw-sales-channel-modal-detail'));

Shopware.Component.override('sw-sales-channel-modal-grid', () => import('./sw-sales-channel-modal-grid'));

Shopware.Component.override('sw-settings-shipping-detail', () => import('./sw-settings-shipping/sw-settings-shipping-detail'));

Shopware.Component.override('sw-extension-card-base', () => import('./sw-extension-card-base'));

export {};
